module.exports = __webpack_public_path__ + "static/enterprise_program_management-e92fb8bd05ea0a5c41539c2b42e77cc1.jpg";